import { useSyncExternalStore } from "react";

type PanelMode = "desktop" | "side-sheet" | "bottom-sheet";

function readPanelMode(): PanelMode {
  if (typeof window === "undefined") return "desktop";
  if (window.matchMedia("(min-width: 1024px)").matches) return "desktop";
  if (window.matchMedia("(min-width: 768px)").matches) return "side-sheet";
  return "bottom-sheet";
}

function subscribeToPanelMode(onChange: () => void): () => void {
  if (typeof window === "undefined") return () => undefined;
  const desktop = window.matchMedia("(min-width: 1024px)");
  const tablet = window.matchMedia("(min-width: 768px)");
  desktop.addEventListener("change", onChange);
  tablet.addEventListener("change", onChange);
  return () => {
    desktop.removeEventListener("change", onChange);
    tablet.removeEventListener("change", onChange);
  };
}

export function usePanelMode(): PanelMode {
  return useSyncExternalStore(subscribeToPanelMode, readPanelMode, () => "desktop");
}
